import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const names = ['María', 'Lucía', 'Valentina', 'Camila', 'Sofía', 'Martina', 'Catalina', 'Elena', 'Isabella', 'Florencia', 'Julieta', 'Agustina'];
const cities = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'Salta', 'Tucumán', 'Mar del Plata', 'La Plata', 'Santa Fe', 'Neuquén'];
export function SalesPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    // Initial delay before first popup (optional, but good for UX)
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 5000);
    const interval = setInterval(() => {
      triggerPopup();
    }, 35000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerPopup = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    setCurrentName(randomName);
    setCurrentCity(randomCity);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
    }, 5000);
  };
  return <AnimatePresence data-id="element-321">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-xl border border-gray-100 p-4 flex items-center gap-3 max-w-[280px] sm:max-w-xs" data-id="element-322">
          <CheckCircleIcon className="w-8 h-8 text-[#22C55E] flex-shrink-0" data-id="element-323" />
          <p className="text-sm text-gray-700 leading-tight font-sans" data-id="element-324">
            <span className="font-bold text-gray-900" data-id="element-325">{currentName}</span>, de{' '}
            <span className="font-bold text-gray-900" data-id="element-326">{currentCity}</span>,
            acaba de comprar el Pack Boba Professional
          </p>
        </motion.div>}
    </AnimatePresence>;
}